import { trackDownload } from '../utils/analytics';

export const APP_STORE_URL = 'https://apps.apple.com/ca/app/flyfinder/id6757250849';

const BADGE_SRC = `${process.env.PUBLIC_URL || ''}/app-store-badge.svg`;

// Official Apple "Download on the App Store" badge (self-hosted SVG).
export const AppStoreBadge = ({ className = 'h-14' }) => (
  <a
    href={APP_STORE_URL}
    target="_blank"
    rel="noopener noreferrer"
    onClick={() => trackDownload()}
    aria-label="Download FlyFinder on the Apple App Store"
    className="inline-block transition-transform duration-300 hover:scale-105"
  >
    <img src={BADGE_SRC} alt="Download on the App Store" className={`${className} w-auto`} />
  </a>
);

// Google Play "Coming Soon" placeholder, sized to visually match the Apple badge.
export const GooglePlaySoon = ({ className = 'h-14' }) => (
  <div
    className={`${className} inline-flex items-center gap-2.5 bg-black border border-white/25 rounded-[9px] px-4 select-none cursor-default`}
    aria-disabled="true"
    title="Coming soon to Google Play"
  >
    <svg viewBox="0 0 24 24" className="w-6 h-6 flex-shrink-0" aria-hidden="true">
      <path fill="#ffffff" fillOpacity="0.55" d="M4 3.5 L20 12 L4 20.5 Z" />
    </svg>
    <span className="text-left leading-tight text-white/70">
      <span className="block text-[10px] uppercase tracking-wide">Coming Soon to</span>
      <span className="block text-sm font-semibold">Google Play</span>
    </span>
  </div>
);

const StoreButtons = ({ className = '', center = true, badgeHeight = 'h-14' }) => (
  <div className={`flex flex-col sm:flex-row gap-4 items-center ${center ? 'justify-center' : ''} ${className}`}>
    <AppStoreBadge className={badgeHeight} />
    <GooglePlaySoon className={badgeHeight} />
  </div>
);

export default StoreButtons;
